module.exports = __webpack_public_path__ + "plat/static/img/end.77e1e943.svg";